import { Pagination } from 'antd';
import { usePaymentInvoicesTableStore } from 'store/paymentInvoicesTable';
import { usePaymentInvoicesTableFiltersStore } from 'store/paymentInvoicesTableFilters';
import { LocalizedConfigProvider } from 'ui/LocalizedConfigProvider';
import type { TComponent } from 'utils/types/component';

export const CustomPagination: TComponent = () => {
    const params = usePaymentInvoicesTableFiltersStore('params');
    const body = usePaymentInvoicesTableFiltersStore('body');
    const totalElements = usePaymentInvoicesTableStore('totalElements');

    const setParams = usePaymentInvoicesTableFiltersStore('setParams');
    const getTable = usePaymentInvoicesTableStore('getTable');

    const page = params.page + 1;

    const handleChangePage = (currentPage: number, pageSize: number) => {
        const enhancePage = currentPage - 1;

        const newParams = { ...params, page: enhancePage, size: pageSize };

        setParams(newParams);
        getTable(body, newParams);
    };

    return (
        <LocalizedConfigProvider>
            <Pagination
                showSizeChanger
                current={page}
                total={totalElements}
                onChange={handleChangePage}
            />
        </LocalizedConfigProvider>
    );
};
